"use client";

import { useState } from "react";
import SolarIcon from "@/components/ui/SolarIcon/SolarIcon";

export default function CopyLinkButton({
    url,
    displayUrl,
    copyLabel,
    copiedLabel,
}) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (e) {
            const textArea = document.createElement("textarea");
            textArea.value = url;
            textArea.style.position = "fixed";
            textArea.style.opacity = "0";
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand("copy");
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } catch (err) {
                // silent
            }
            document.body.removeChild(textArea);
        }
    };

    return (
        <button
            type="button"
            onClick={handleCopy}
            className="group inline-flex flex-col sm:flex-row items-stretch border border-gray-200 dark:border-bgDark-300 bg-white dark:bg-bgDark-840 hover:border-primary/40 dark:hover:border-primary/40 transition-colors rounded-2xl sm:rounded-full overflow-hidden shadow-sm w-full max-w-sm sm:max-w-none sm:w-auto"
        >
            <span className="flex items-center justify-center sm:justify-start px-4 sm:px-5 py-3 font-mono text-[11px] sm:text-xs text-gray-600 dark:text-grayDark-300 truncate">
                {displayUrl}
            </span>
            <span
                aria-hidden="true"
                className="block h-px w-full sm:h-auto sm:w-px bg-gray-200 dark:bg-bgDark-300 group-hover:bg-primary/30 transition-colors"
            ></span>
            <span className="flex items-center gap-2 px-4 sm:px-5 py-3 bg-primary text-primary-foreground text-sm font-semibold group-hover:bg-[#d04816] transition-colors sm:min-w-[140px] justify-center">
                {copied ? (
                    <>
                        <SolarIcon
                            name="check-circle-bold"
                            className="w-4 h-4 shrink-0"
                        />
                        <span>{copiedLabel}</span>
                    </>
                ) : (
                    <>
                        <SolarIcon
                            name="copy-bold-duotone"
                            className="w-4 h-4 shrink-0"
                        />
                        <span>{copyLabel}</span>
                    </>
                )}
            </span>
        </button>
    );
}
